import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'durationStatus',
  standalone: false,
})
export class DurationStatusPipe implements PipeTransform {
  transform(date: string): string {
    const now = new Date().getTime();
    const dateToCompare = new Date(date).getTime();

    if (now > dateToCompare) {
      return 'ended';
    }

    return 'ongoing';
  }
}
